import { useState } from "react"
import { TextField, Visibility, VisibilityOff, Typography } from "./MyCustomFile"
import { InputAdornment, IconButton } from '@mui/material';
const MyInputPassword = ({ name, label, value, onChange, error, helperText, disabled }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleTogglePasswordVisibility = () => setShowPassword(!showPassword)
    return (<>
        <TextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            margin="dense"
            size="small"
            name={name}
            label={label}
            disabled={disabled}
            value={value || ''}
            onChange={onChange}
            error={Boolean(error)}
            InputProps={{
                endAdornment: (<InputAdornment position="end">
                    <IconButton onClick={handleTogglePasswordVisibility} disabled={disabled}>{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
                </InputAdornment>),
            }}
        />
        {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
    </>);
}
export default MyInputPassword